import createSvgIcon from '../Utils/CreateSvgIcon';

export const Horsepower = createSvgIcon(
  <path
    d="M11 6L8 6V4L11 4L13 4L16 4V6H13V7H16H16.4525L16.7512 7.33989L18.7512 9.61575L19 9.8989V10.2759L19 16.7241V17.1011L18.7512 17.3843L16.7512 19.6601L16.4525 20H16H8H7.54752L7.24884 19.6601L5.24884 17.3843L5 17.1011V16.7241V14H4L4 16H2L2 10H4L4 12H5L5 10.2759V9.8989L5.24884 9.61575L7.24884 7.33989L7.54752 7H8L11 7V6ZM8.45248 9L7 10.6528L7 16.3472L8.45248 18H15.5475L17 16.3472V10.6528L15.5475 9L8.45248 9ZM20 16L20 11H22L22 16H20ZM12.8492 9.74074L9.84921 12.3122L8.43754 13.5222L10.2253 14.033L11.4375 14.3793L9.84921 15.7407L11.1508 17.2593L14.1508 14.6878L15.5625 13.4778L13.7747 12.967L12.5625 12.6207L14.1508 11.2593L12.8492 9.74074Z"
    fillRule="evenodd"
  />,
  'Horsepower',
);
